exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app[data-v-35dbc180]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;margin-top:1.6rem}.icon-add-50[data-v-35dbc180]{position:fixed;display:flex;justify-content:center;align-items:center;z-index:999}", ""]);

// exports
